import { paths } from "helpers/paths";
import { useRouter } from "hooks/useRouter";
import Tooltip from "rc-tooltip";
import React, { useState } from "react";
import { removeCars } from "sources/books/usersGroups";
import MoveGroup from "./moveGroup";

export default function GroupItem(props) {
    const { history } = useRouter();

    const { modal, carId, useUniqueUsersGroups, refreshData, onRemove } = props;
    const [show, setShow] = useState(true);
    const [group, setGroup] = useState(props.group);
    if (!show) {
        return null;
    }
    const handleDelete = () => {
        modal({
            name: "confirm",
            title: "Удаление",
            text: "Вы уверены, что хотите удалить машину из группы?",
            buttons: { confirm: "Удалить", cancel: "Отменить" },
            action: () =>
                removeCars({ groupId: group.id, carIds: [carId] }).then(() => {
                    setShow(false);
                    if (onRemove) {
                        onRemove();
                    }
                }),
        });
    };
    const handleMove = () => {
        modal({
            name: "default",
            title: "Перенос машины в другую группу",
            windowMod: "sm",
            CustomBody: MoveGroup,
            bodyData: { group, carId, setGroup, useUniqueUsersGroups, refreshData },
        });
    };

    const toGroup = () => {
        history.push(paths.usersGroupsShow(group.id));
    };

    return (
        <div className="d-inline-flex w-100 align-items-center">
            <div className="ellipsis-auto">
                <div className="badge badge-primary badge-pill cursor-pointer" onClick={toGroup} title={group.name}>
                    {group.name}
                </div>
            </div>
            <Tooltip overlay="Перенести машину в другую группу">
                <div className="btn btn-xs text-primary mr-1 ml-2 inline-icon" onClick={handleMove}>
                    <i className="icon-uEA74-exchange" />
                </div>
            </Tooltip>
            <Tooltip overlay="Удалить машину из группы">
                <div className="btn btn-xs text-danger inline-icon" onClick={handleDelete}>
                    <i className="icon-uEA07-delite" />
                </div>
            </Tooltip>
        </div>
    );
}
